import {FbFormObject} from '../class/fb_form_object';

export class IfaMember extends FbFormObject {
    /**
     * override default columns
     */
    public setColumns() {
        this.column_definition = [
            {id: 'joined_at', label: 'joined at', visible: true, noclick: false, disable_ripple: true},
            {id: 'nick', label: 'Nick', visible: true, noclick: false, disable_ripple: true},
            {id: 'username', label: 'Username', visible: true, noclick: false, disable_ripple: true},
            {id: 'global_name', label: 'global Name', visible: true, noclick: false, disable_ripple: true},
            {id: 'max_rank_name', label: 'max Rank', visible: true, noclick: false, disable_ripple: true}
        ];
    }

    /**
     * override default fields
     */
    public setEditFields() {
        this.edit_fields = [
            {
                caption: 'User',
                class: 'card card-1 padding',
                field_class: '',
                fields: [
                    {
                        type: 'datetime',
                        name: 'joined_at',
                        disabled: true
                    },
                    {
                        type: 'text',
                        name: 'nick',
                        disabled: true
                    },
                    {
                        type: 'text',
                        name: 'username',
                        disabled: true
                    },
                    {
                        type: 'text',
                        name: 'global_name',
                        disabled: true
                    },
                    {
                        type: 'text',
                        name: 'max_rank_name',
                        disabled: true
                    }
                ]
            }
        ];
        super.setEditFields();
    }

    public loadStores(ext_obj?: any): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            this.stores['ifa_member'] = this.storeService.getStore('ifa_member');
            this.main_store = this.stores['ifa_member'];

            const stores = [];
            if (!this.stores['ifa_member'].isLoaded()) {
                stores.push(this.stores['ifa_member'].loadStore(this.filter));
            }

            Promise.all(stores).then((result) => {
                resolve(true);
            });
        });
    }

    public getDefaultModel() {
        return {
            data: {
                user_id: 0
            }
        };
    }

    /**
     * custom reload
     */
    public reload(): Promise<any> {
        return this.getStore().loadStore('');
    }

    /**
     * override select_boxes
     */
    public setSelectboxes() {
        // call super
        super.setSelectboxes();
    }
}
